import MuiBackdrop from '@mui/material/Backdrop';
import { alpha, hexToRgb } from '@mui/system';

import { styled } from 'helpers';

import { BackdropProps } from './index';

export const Backdrop = styled(MuiBackdrop)<BackdropProps>`
  background-color: ${({ theme }) => `${alpha(hexToRgb(theme.palette.secondary.contrastText), 0.4)}`};
`;
